import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@mantine/core';

import style from '../connection-sync-table.module.css';

export const SyncErrorPopover = ({ message }: { message: string }) => (
  <Tooltip label={message}>
    <span className={style['sync-error-icon']}>
      <FontAwesomeIcon icon={faCircleExclamation} />
    </span>
  </Tooltip>
);
